import { Card, Table } from 'components/core-v2'

import { plural } from '../../../../utilities/plural'
import { useFilteredGetByTenantAccountDashboardQuery } from '../../utils/useFilteredNotes'
import { COLUMN_DEFS, DEFAULT_COLUMN_OPTIONS } from './columns'
import { Loading } from './Loading'

export const AssetsTable = () => {
  const { data, isFetching, isLoading } = useFilteredGetByTenantAccountDashboardQuery()

  if (isLoading || isFetching) return <Loading />

  const assetCount = data.assets.length
  const title = `${assetCount} total ${plural('Asset', assetCount)}`

  return (
    <Card.Wrapper>
      <Card.Header title={title} />
      <Table
        agGridProps={{
          columnDefs: COLUMN_DEFS,
          defaultColDef: DEFAULT_COLUMN_OPTIONS,
          headerHeight: 60,
          rowData: data.assets,
          rowHeight: 44
        }}
        height="400px"
      />
    </Card.Wrapper>
  )
}
